export default __webpack_public_path__ + "static/media/instaprof.71a24f68.jp2";